export function isValidEmail(value: string) {
  // Simple, pragmatic check; backend should validate strictly.
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}
